import { useEffect, useState } from 'react';

import { ApiTileCarouselResult } from 'api/types/ApiTileCarouselResult';
import { AreaOfFocus, JobFunction } from 'utils/constants';
import { log } from 'utils/logging';
import { getRecommendedJobs } from 'utils/search/getRecommendedJobs';

/*
 * Fetch recommended jobs
 */
export function useRecommendedJobs(
  searchLocation: Partial<SearchLocation> &
    Pick<SearchLocation, 'latitude' | 'longitude'>,
  options?: {
    onlyWithLogo: boolean;
    jobFunction?: JobFunction | null;
    areaOfFocus?: AreaOfFocus | null;
    jobTitle?: string;
    familyId?: string;
    query?: string;
  },
) {
  // @ts-expect-error TS(2339): Property 'onlyWithLogo' does not exist on type '{ ... Remove this comment to see the full error message
  const { onlyWithLogo, jobFunction, areaOfFocus, familyId } = options;

  const [data, setData] = useState<ApiTileCarouselResult[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    getRecommendedJobs({
      searchLocation,
      options: {
        onlyWithLogo,
        jobFunction,
        areaOfFocus,
        familyId,
      },
      searchOptions: { distinct: true },
    })
      .then((jobs) => {
        setData(
          jobs.map((job) => ({
            city: job.city,
            id: job.objectID,
            logo: job.logo,
            orgName: job.orgName,
            name: job.name,
            state: job.state,
            url: job.url,
          })),
        );
      })
      .catch((e) => {
        setError(e);
        log.error(e);
      })
      .finally(() => setIsLoading(false));
  }, [searchLocation, onlyWithLogo, jobFunction, areaOfFocus, familyId]);

  return { data, isLoading, error };
}
